/* eslint-disable react-hooks/exhaustive-deps */
import DetailList from "common/components/DetailList"
import FilterMenu from "common/components/FilterMenu"
import { QUERY_PARAMETERS } from "common/constants"
import useFilters from "common/hooks/useFilters"
import useToggle from "common/hooks/useToggle"
import FacturaRecurrenteService from "common/services/FacturaRecurrenteService"
import moment from "moment"
import { useCallback, useState } from "react"
import { useTranslation } from "react-i18next"
import { onGetColumns } from "../../constants"
import "../../style.scss"
import ModalOmitirFactura from "../ModalOmitirFactura"

const FacturasDetailList = ({
  documentoRecurrenteId,
  intervalo,
  startDate,
  razonSocial,
  handleOpenModalFacturaDetail,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [showModal, toggleShowModal] = useToggle(false)
  const [selectedFactura, setSelectedFactura] = useState({})

  const fetchItems = useCallback(
    (queryState: $TSMigrationFixMe) => {
      if (queryState.includes(QUERY_PARAMETERS.FechaLowerLimit)) {
        return FacturaRecurrenteService.getFacturasRecurrentesHistoricas(
          documentoRecurrenteId,
          queryState
        )
      }
      return FacturaRecurrenteService.getFacturasRecurrentesHistoricas(
        documentoRecurrenteId,
        ""
      )
    },
    [documentoRecurrenteId]
  )

  const {
    handleFilter,
    resetFilters,
    onConfirmFilters,
    data,
    selectedOptions,
    handleRemoveFilter,
    setSelectedOptions,
    query,
    setQuery,
    // @ts-expect-error TS(2554): Expected 6 arguments, but got 2.
  } = useFilters(fetchItems, [startDate])

  const handleOpenModalOmitir = (factura: $TSMigrationFixMe) => {
    const selectedFactura = { ...factura, razonSocial }
    setSelectedFactura(selectedFactura)
    toggleShowModal()
  }

  const handleConfirmOmitirFactura = async (factura: $TSMigrationFixMe) => {
    const fechaOmision = moment(factura.fechaOperacion).format("YYYY-MM-DD")

    await FacturaRecurrenteService.omitFacturaRecurrente(
      documentoRecurrenteId,
      fechaOmision
    )
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 0.
    onConfirmFilters()
    toggleShowModal()
  }

  return (
    <div className='mb-4 '>
      <div className='mt-4 mb-4 d-flex justify-content-end'>
        {data.length ? (
          <FilterMenu
            handleFilter={handleFilter}
            resetFilters={resetFilters}
            onConfirmFilters={onConfirmFilters}
            isOnlyDate
            buttonLabel='Fechas'
            icon='calendar-lines'
            buttonColor='white'
            fechaFilterActive
            menuClassname='filter-date'
            dateFilterKeys={[
              QUERY_PARAMETERS.FechaLowerLimit,
              QUERY_PARAMETERS.FechaUpperLimit,
            ]}
            intervalo={intervalo}
            existQuery={Boolean(selectedOptions?.length)}
            selectedOptions={selectedOptions}
            // @ts-expect-error TS(2339): Property 'fechaOperacion' does not exist on type '...
            lastDate={moment(data?.[data.length - 1]?.fechaOperacion)}
            // @ts-expect-error TS(2339): Property 'fechaOperacion' does not exist on type '...
            startDate={moment(data?.[0]?.fechaOperacion)}
            filterActiveInitialState
            handleRemoveFilter={handleRemoveFilter}
            disableDateTag
            setSelectedOptions={setSelectedOptions}
            query={query}
            setQuery={setQuery}
          />
        ) : null}
      </div>
      <DetailList
        data={data}
        onClickRow={handleOpenModalOmitir}
        activeConditionKey='estado'
        columns={() => onGetColumns(handleOpenModalFacturaDetail, t)}
      />
      <ModalOmitirFactura
        show={showModal}
        setShow={toggleShowModal}
        facturaInfo={selectedFactura}
        handleConfirmOmitirFactura={handleConfirmOmitirFactura}
      />
    </div>
  )
}

export default FacturasDetailList
